export class Popover {
    /**
     * Selectors
     */
    private readonly triggerSelector = '.js-popover-trigger';
    private readonly popoverSelector = '.js-popover';
    private readonly closeSelector = '.js-popover-close';
    private readonly contentSelector = '.js-popover-content';
    private readonly popupBaseParentTemplateSelector = '.js-popover-trigger-template';

    /**
     * Classes
     */
    private readonly activeClass = 'is-popover-active';

    /**
     * Elements
     */
    private readonly triggerList: HTMLElement[];
    private readonly popoverElem: HTMLElement;
    constructor() {
        this.triggerList = Array.from(document.querySelectorAll<HTMLElement>(this.triggerSelector));
        this.popoverElem = document.querySelector(this.popoverSelector);

        if (this.triggerList.length) {
            this.listen();
        }
    }

    private listen() {
        this.triggerList.forEach(trigger => trigger.addEventListener('click', ev => this.onClick(ev)));
        this.popoverElem.addEventListener('click', ev => this.onPopupClick(ev));
        document.addEventListener('keydown', ev => ev.key === 'Escape' && this.togglePopupVisibility(false));

        if (location.hash) {
            window.requestAnimationFrame(() => {
                this.triggerList
                    .find(trigger => trigger.getAttribute('data-hash-trigger') === location.hash)
                    ?.click();
            });
        }
    }

    /**
     * User clicks the trigger
     * @param ev
     * @private
     */
    private onClick(ev: MouseEvent) {
        ev.preventDefault();

        const trigger: HTMLElement = ev.currentTarget as HTMLElement;

        const templateSelectors = trigger.getAttribute('data-template')?.split('|');

        if (templateSelectors) {
            const baseElem = trigger.closest(this.popupBaseParentTemplateSelector);
            templateSelectors.forEach(template => {
                const elemContent = baseElem.querySelector(`[${template}]`)?.innerHTML || '';

                const elemTarget = this.popoverElem.querySelector(`[${template}]`);

                if (template.includes('url')) {
                    (elemTarget as HTMLLinkElement).href = elemContent;
                } else {
                    elemTarget.innerHTML = elemContent;
                }
            });
        }

        if (trigger.getAttribute('data-hash-trigger')) {
            location.hash = trigger.getAttribute('data-hash-trigger');
        }

        this.togglePopupVisibility(true);
    }

    /**
     * User clicks inside popup elem
     * @param ev
     * @private
     */
    private onPopupClick(ev: MouseEvent) {
        const target = ev.target as HTMLElement;
        if (!target.closest('.js-menu-toggle') && (target.closest(this.closeSelector) || !target.closest(this.contentSelector))) {
            this.togglePopupVisibility(false);
        }
    }

    /**
     * Add UI class to popup to show/hide
     * @param b
     * @private
     */
    private togglePopupVisibility(b: boolean) {
        document.documentElement.classList.toggle(this.activeClass, b);
    }
}
